import React, { useEffect, useState } from 'react'
import '../styling/containerStyles.css';
import { getBase64 } from './Functions/imageCompress';
import ButtonComp from '../components/button'
import Button from '@material-ui/core/Button';
import { Grid } from "@material-ui/core";
import DialogCamera from './dialogCamera';
import profilePic from '../assets/images/avatar3.png'
import Label from '../components/label'
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import CircularProgress from '@material-ui/core/CircularProgress';
import Typography from "@material-ui/core/Typography";
import { handleImageUpload, handleDeleteImage } from './Functions/azureFile';

interface ImageUploadPageProps {
    setIsOnfidoPage: any;
    idfyDocData?: any;
    membershipID: any;
    faceCompare: Function;
    getSelfieFile: Function;
    faceLiveMessage?: any;

}
let imageChange = false;

export const ImageUploadPage: React.FC<ImageUploadPageProps> = (props: ImageUploadPageProps) => {

    const {
        setIsOnfidoPage, membershipID, faceCompare, getSelfieFile, faceLiveMessage, idfyDocData
    } = props;

    const [uploadImage, setUploadImage] = useState(false);
    const [imageUrl, setImageUrl] = useState("");
    const [imagesData, setImagesData] = useState([]);
    const [contractorImage, setContractorImage] = useState([]);
    const [imageProgress, setImageProgress] = useState(0);

    useEffect(() => {
        // getSelfieFile()
    }, [])

     const getImgUploadProgess = (progress:any) => {
        setImageProgress(progress);
        if (progress < 100) {
            return;
        }
    }

    const dialogOpen = async (props: any, data: any) => {
        imageChange = true;
        setUploadImage(!uploadImage)
        if (idfyDocData.face_img) {
            await handleDeleteImage(idfyDocData.face_img);
        } else if (imageUrl) {
            await handleDeleteImage(imageUrl);
        }
        if (data && data.base64) {
            // Previous code start here
            // const compImage = await getBase64(data.base64) as string;
            // setContractorImage(data)
            // setImageUrl(compImage)
            // prevouts code end here
            const res = await handleImageUpload(data.base64, getImgUploadProgess, "kyc");
            
            if (res && res[0] && res[0].normal_url) {
                setImageUrl(res[0].normal_url);
            } else {
                setImageUrl('');
            }
            // setImagesData(data)
            getSelfieFile(res[0].normal_url)
        }
    };

    const handleSubmitImage = async () => {
        await faceCompare();
    }
    
    return (
        <div className='doc-upload-main'>

            <div className='buttonAndLabel'>
                    <Button className='goBack' ><ArrowBackIosIcon /></Button>
                    <Label content='Online KYC Verification' />
            </div>
            <br></br>
            <Grid item xs={12} style={{ textAlign: "center" }}>
                <img style={{ width: 130, height: 130, borderRadius: "50%" }}
                    src={imageUrl && imageUrl ? imageUrl : profilePic}
                    alt="KYC Profile" />

                {(imageProgress !== 0 && imageProgress < 100) && (
                    <div className='img-progress-bar'>
                        <CircularProgress size={34} />
                        <Typography variant="caption" component="div" >
                            {`${Math.round(imageProgress)}%`}
                        </Typography>
                    </div>
                )}
                    
                <div className="selfie_btn_paytm2 button">
                    <Button
                        onClick={async (e) => {
                            (setUploadImage(true))
                        }}>Upload selfie</Button></div>

                {
                    <p style={{ color: "red", margin: '8px 0px 0px', display: 'flex', justifyContent: "center" }}>
                        {faceLiveMessage}
                    </p>
                }
            </Grid>
            <DialogCamera
                cameraProps={props}
                openDialog={uploadImage}
                updatestate={dialogOpen}
                openWebcam={true}
            />
            <ButtonComp label={'PROCEED'}
                name={'PROCEED'}
                visible={true}
                disabled={!imageUrl}
                handleToUpdate={handleSubmitImage}
            />

        </div>
    )
}
export default ImageUploadPage